import React from "react";
import {
  DefaultButton,
  ComboBox,
  IComboBoxOption,
  Label,
  Stack,
} from "@fluentui/react";

export const defaultPaginationOptions: IComboBoxOption[] = [
  { key: 10, text: "10" },
  { key: 30, text: "30" },
  { key: 60, text: "60" },
  { key: 100, text: "100" },
];

type PaginationProps = {
  page: number;
  setPage: (n: number) => void;
  take: number;
  setTake: (n: number) => void;
  options?: IComboBoxOption[];
  disablePrev: boolean;
  disableNext: boolean;
};

export const Pagination: React.FC<PaginationProps> = ({
  page,
  setPage,
  take,
  setTake,
  options,
  disablePrev,
  disableNext,
}) => (
  <Stack horizontal tokens={{ childrenGap: 6 }} style={{ padding: 12 }}>
    <DefaultButton
      text="Previous"
      onClick={() => setPage(page - 1)}
      disabled={disablePrev}
    />
    <DefaultButton
      text="Next"
      onClick={() => setPage(page + 1)}
      disabled={disableNext}
    />
    <ComboBox
      selectedKey={take}
      options={options || defaultPaginationOptions}
      onChange={(_, option) => option && setTake(option.key as number)}
      styles={{ root: { width: 100 } }}
    />
    <Label>Page {page}</Label>
  </Stack>
);
